import moment from 'moment'
import {
  DATE_FORMAT,
  DATE_FORMAT_SHORT,
  TIME_FORMAT_BASE,
} from '@/constants/dateFormats'

export const addressToString = (address) => {
  if (!address) {
    return ''
  }

  const { building, city, street, zip_code } = address

  return `${zip_code}, ${city}, ${street}${building ? `, ${building}` : ''}`
}

export const dateFormatter = ({
  date,
  format = DATE_FORMAT,
  emptyText = '-',
}) => {
  if (!date) {
    return emptyText
  }

  return moment(date).format(format)
}

export const timeFormatter = ({
  time,
  format = TIME_FORMAT_BASE,
  emptyText = '-',
}) => {
  if (!time) {
    return emptyText
  }

  return moment(time, 'hh:mm:ss').format(format)
}

export const datesRange = ({
  from,
  to,
  format = DATE_FORMAT_SHORT,
  sameDiff = 'month',
}) => {
  if (!from || !to) {
    return ''
  }

  const fromMoment = moment(from)
  const toMoment = moment(to)

  if (from === to) {
    return fromMoment.format(format)
  }

  const isSame = toMoment.isSame(fromMoment, sameDiff)

  return `${fromMoment.format(format)} - ${toMoment.format(
    !isSame ? format : 'DD'
  )}`
}

export const capitalizeFirstLetter = (string) => {
  return string && string.charAt(0).toUpperCase() + string.slice(1)
}

export const fullName = ({ firstName, lastName }) => {
  if (!firstName || !lastName) {
    return ''
  }

  return `${firstName} ${lastName}`
}

export const priceFormatter = ({ price, currency = 'USD' }) => {
  return parseInt(price)
    ? parseFloat(price).toLocaleString('en-US', { style: 'currency', currency })
    : ''
}

export const formatPhoneNumber = (value) => {
  if (!value) return ''
  const cleaned = value.replace(/\D/g, '')
  if (cleaned.length <= 3) return cleaned
  if (cleaned.length <= 6) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`
}

export const formatSSN = (value) => {
  if (!value) return ''
  const cleaned = value.replace(/\D/g, '')
  if (cleaned.length <= 3) return cleaned
  if (cleaned.length <= 5) return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`
  return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 5)} ${cleaned.slice(5, 9)}`
}

export const stripPhoneFormatting = (value) => {
  if (!value) return ''
  return String(value).replace(/\D/g, '')
}

export const stripSSNFormatting = (value) => {
  if (!value) return ''
  return String(value).replace(/\D/g, '')
}
